var map = {
	"./1.jpg": 516,
	"./10.jpg": 1524,
	"./11.jpeg": 5692,
	"./12.jpeg": 9112,
	"./13.jpeg": 584,
	"./15.jpg": 5868,
	"./2.jpg": 1312,
	"./3.jpg": 8080,
	"./5.jpg": 3096,
	"./6.jpg": 4084,
	"./7.jpg": 1276,
	"./8.jpg": 1004,
	"./9.jpg": 9004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1184;